import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import "./alertmessage.scss";

const AlertMessage = (props) => {
    const { open, header, body, footer } = props;

    return (
        <Dialog open={open} className="Comman-dialog-box">
            <DialogTitle component={"div"}>{header}</DialogTitle>
            <DialogContent className="common-dialog-content"><>{body}</></DialogContent>
            <DialogActions className="common-dialog-btn">
                <>
                    {footer}
                </>
            </DialogActions>
        </Dialog>
    );
}

export default AlertMessage;

